export type ProgressMilestoneKey =
  | 'companyInfo'
  | 'templateHeader'
  | 'properties'
  | 'hospitalityLanding'
  | 'hospitalityProperties';

export interface FieldMissingDetail {
  type: 'field';
  key: string;
}

export interface PropertyMissingDetail {
  type: 'property';
  propertyId?: string;
  address?: string;
  sections: string[];
}

export type MissingDetail = FieldMissingDetail | PropertyMissingDetail;

export interface ProgressMilestone {
  key: ProgressMilestoneKey;
  weight: number;
  completed: boolean;
  missingSections?: MissingDetail[];
}

export function getMilestoneRoute(key: ProgressMilestoneKey): string {
  switch (key) {
    case 'templateHeader':
    case 'properties':
    case 'hospitalityProperties':
      return '/properties';
    case 'companyInfo':
    case 'hospitalityLanding':
    default:
      return '/company';
  }
}

export interface ProgressNavigationOptions {
  autoOpenAddProperty?: boolean;
}

export function getMilestoneQueryParams(
  key: ProgressMilestoneKey,
  options: ProgressNavigationOptions = {}
): Record<string, any> {
  if (key === 'templateHeader') {
    return { openExcelWizard: '1' };
  }
  if (key === 'properties' && options.autoOpenAddProperty) {
    return { openAddProperty: '1' };
  }
  return {};
}
